t = require('views/internal/teacup-with-helpers')('popover_reopen_board')
localizeCount = require 'lib/localize-count'

module.exports = t.renderable ->
  t.div '.js-billable-guests-alert'
  t.input '.primary.full.js-confirm-reopen', { type: 'submit', value: t.l('confirm') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_reopen_board.coffee